<template>
    <div id="nav">
        <ul>
            <li v-for="link in links" :class="[$route.name === link.name ? 'active' : '']">
                <router-link :to="{ path: link.path }">{{ link.text }}</router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    computed: {
        links() {
            const links = this.$store.getters['ui/navigationLinks'];
            return links;
        },
    },
};
</script>

<style lang="sass" scoped>
</style>